<template>
    <div>
        <div class="row" v-if="data != null">
            <div class="col-md-12">
                <div class="card">
                <div class="card-header card-header-info">
                    <h4 class="card-title ">{{"History Saldo '"+data.nama+"'"}}</h4>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table">
                            <thead class=" text-info">
                                <th width="20px">No.</th>
                                <th>Keterangan</th>
                                <th>Jumlah</th>
                                <th>Sisa Saldo</th>
                                <th>Jam</th>
                                <th>Tanggal</th>
                            </thead>
                            <tbody>
                                <tr v-for="(ser, index) in data.history">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ ser.keterangan }}</td>
                                    <td>{{ ribu(ser.jumlah) }}</td>
                                    <td class="text-info">{{ ribu(ser.sisa_saldo) }}</td>
                                    <td>{{ ser.jam }}</td>
                                    <td>{{ tglIndo(ser.tanggal) }}</td>
                                </tr>
                                <tr v-if="data.history.length == 0">
                                    <td></td>
                                    <td>Tidak ada Data</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
	components: { 

	}, 
  setup() {
    const data = reactive({
        history: [],
        username: '',
        id: '',
        nama: ''
    })
    const detail = {
      form : reactive({
        alert: null,
        alertSuccess: null
      }),
      get() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            from: "admin",
            id: data.id
        }
        
        var apiUrl = inter.kangVoucherHistory();
        myGlobal.call(datax,apiUrl).then(x => {
            // myGlobal.loger(x);
            if (x.status == true) {
                data.history = x.data;
            } else {
            //alert(x.pesan);
            }
        })
      }
    }
    return {
      data,
      myGlobal,
      detail
    }
  },
  mounted () {
    document.title = "History Admin";

    this.data.id = this.$route.params.id;

    this.data.nama = sessionStorage.getItem("VoucherNama");

    this.detail.get();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/kang-voucher/detail/history.vue